export default __webpack_public_path__ + "static/media/Communication.29cb64d1.jpg";